import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
} from "../services/types/ComponentTypes";
import {
    VOID_CONFIRM_MESSAGE,
    VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_163_credit_note_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        fabAction: {
            type: "add",
            screenId: "165",
        },
        title: "Credit note",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    borderRadius: 12,
                    padding: 16,
                },
                childComponents: [
                    {
                        componentType: LayoutTypes.GROUP,
                        Label: "",
                        BindValue: "cont_Action",
                        style: {
                            direction: FlexDirection.ROW,
                            padding: 0,
                            margin: 0,
                            marginBottom: 8,
                        },
                        childComponents: [],
                    },
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "voucher_no",
                        Name: "credit_note_summary",
                        BindValue: "grid_credit_note",
                        SummeryActions: [
                            {
                                ActionType: ActionType.VIEW_REPORT,
                                Action: {
                                    Action: "Report",
                                    Api: "credit_notes_view",
                                },
                                tooltip: "View Report",
                            },
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "modulev1/credit_note/<id>",
                                },
                                ActionType: "Edit",
                                ScreenId: "165",
                                hiddenWhenVoid: true,
                            },
                                                        {
                              ActionType: ActionType.VOID,
                              permissionKey: "Void",
                              confirmMessage: VOID_CONFIRM_MESSAGE,
                              requireVoidReason: true,
                              hiddenWhenVoid: true,
                              visibleWhenNotDraft: true,
                              voidReasonLabel: "Void Reason",
                              tooltip: "Void",
                              Action: {
                                Module: "credit_note_add",
                                TransactionNoField: "voucher_no",
                              },
                            },
                            {
                                Action: {
                                    Action: "PDF",
                                    Settings: "credit_notes",
                                },
                                ActionType: ActionType.PDF_DOWNLOAD,
                                tooltip: "Download PDF",
                            },
                        ],
                        Form: {
                            Name: "credit_note_summary",
                            TableName: "vouchers",
                            DisplayName: "vouchers",
                            Query:
                                "SELECT `vouchers`.id,vouchers.voucher_no,`voucher_date`,vouchers.`total_credit`,users.username,(SELECT users.username FROM users WHERE id=modified_by limit 1) AS modified_by,vouchers.is_void,CASE WHEN COALESCE(vouchers.is_void,0)=1 THEN 'Void' ELSE '' END AS status FROM vouchers LEFT JOIN users ON users.id=vouchers.created_by OR  users.id=vouchers.modified_by WHERE voucher_type='CreditNote' AND vouchers.transaction_branch_id = '<branch_id>'",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "id",
                                    BindValue: "id",
                                    Json_Attribute: "id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: false,
                                    IsPrimary: true,
                                },
                                VOID_STATUS_FIELD,
                                {
                                    IncludeLabel: true,
                                    Label: "Voucher No.",
                                    BindValue: "txt_voucher_no",
                                    Json_Attribute: "voucher_no",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Voucher date",
                                    IsMandatory: false,
                                    BindValue: "txt_date",
                                    Json_Attribute: "voucher_date",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Narration",
                                    BindValue: "txt_narration",
                                    Json_Attribute: "narration",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Credit amount",
                                    BindValue: "txt_est",
                                    Json_Attribute: "total_credit",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Created by",
                                    BindValue: "txt_created_by",
                                    Json_Attribute: "username",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
